import NoDataUrl from '@/assets/global/noData.png';
import styles from './index.less';
const NoData = () => {
  return (
    <div className={styles.container}>
      <img src={NoDataUrl} alt={'no-data'} />
      <p>暂无数据</p>
    </div>
  );
};
export default NoData;
